import { InputMultiSelectActions } from './components/input-multi-select-actions'
import { InputMultiSelectClearButton } from './components/input-multi-select-clear-button'
import { InputMultiSelectField } from './components/input-multi-select-field'
import { InputMultiSelectHelperText } from './components/input-multi-select-helpertext'
import { InputMultiSelectIcon } from './components/input-multi-select-icon'
import { InputMultiSelectLabel } from './components/input-multi-select-label'
import { InputMultiSelectQuantity } from './components/input-multi-select-quantity'

import { type Scope, createContextScope } from '@radix-ui/react-context'

import { renderCompositionChildren } from './utils/render-composition-children'

import { useState } from 'react'
import { InputMultiSelectDropdown } from './components/input-multi-select-dropdown'
import { InputMultiSelectRootStyles } from './input-multi-select.styles'
import type {
  InputMultiSelectContext,
  InputMultiSelectProps,
  InputMultiSelectScopedProps,
} from './input-multi-select.types'

const DISPLAY_NAME = 'InputMultiSelect'

const InputMultiSelectRoot = (
  props: InputMultiSelectScopedProps<InputMultiSelectProps>
) => {
  const { size = 'ml', children, __scopeInputMultiSelect } = props
  const [isActive, setActive] = useState(false)

  return (
    <InputMultiSelectProvider
      {...props}
      size={size}
      scope={__scopeInputMultiSelect}
      isActive={isActive}
      setActive={setActive}
    >
      <div
        className={InputMultiSelectRootStyles({
          disabled: props.disabled,
          readonly: props.readonly,
        })}
      >
        {renderCompositionChildren(children, [
          { child: InputMultiSelect.Label, amount: 1 },
          { child: InputMultiSelect.Actions, amount: 1 },
          { child: InputMultiSelect.HelperText, amount: 1 },
          { child: InputMultiSelect.Dropdown, amount: 1 },
        ])}
      </div>
    </InputMultiSelectProvider>
  )
}

InputMultiSelectRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

const [createInputMultiSelectContext] = createContextScope(DISPLAY_NAME)

export const [InputMultiSelectProvider, useInputMultiSelectContext]: readonly [
  ProviderType<InputMultiSelectContext>,
  (consumerName: string, scope: Scope) => InputMultiSelectContext,
] = createInputMultiSelectContext<InputMultiSelectContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const InputMultiSelect = {
  Root: InputMultiSelectRoot,
  Label: InputMultiSelectLabel,
  HelperText: InputMultiSelectHelperText,
  Actions: InputMultiSelectActions,
  ClearButton: InputMultiSelectClearButton,
  Icon: InputMultiSelectIcon,
  Field: InputMultiSelectField,
  Quantity: InputMultiSelectQuantity,
  Dropdown: InputMultiSelectDropdown,
}
